import "./App.css";
import Navbar from "./Navbar/Navbar";
import Header from "./Header/Header";
import Game from "./Game/Game";
import Main from "./Main/Main";
import Lead from "./Lead/lead";
import Footer from "./Footer/Footer";
import Last from "./Last/Last";
function App() {
  return (
    <div>
      <Navbar />
      <Header />
      <Game />
      <Main />
      <Lead />
      <Footer />
      <Last/>
    </div>
  );
}

export default App;
